/**
 * Custom `FormConfigPage.onNavBack` handler for the facility locator page.
 *
 * If the user is navigating in review mode, returns them to the
 * review-and-submit page instead of following the default back navigation.
 * Otherwise, continues with the standard previous-page navigation.
 *
 * @param {Object} params
 * @param {(path: string) => void} params.goPath
 * @param {(urlParams?: object) => void} params.goPreviousPath
 * @param {object} params.urlParams
 */
export const facilityLocatorNavBack = ({
  goPath,
  goPreviousPath,
  urlParams,
}) => {
  if (urlParams?.review === 'true') return goPath('/review-and-submit');
  return goPreviousPath();
};

/**
 * Custom `FormConfigPage.onNavBack` handler for the facility confirmation page.
 *
 * If the user is navigating in review mode, returns them to the facility
 * locator page while preserving the current URL parameters. Otherwise,
 * continues with the standard previous-page navigation.
 *
 * @param {Object} params
 * @param {(urlParams?: object) => void} params.goPreviousPath
 * @param {object} params.urlParams
 */
export const facilityConfirmationNavBack = ({ goPreviousPath, urlParams }) => {
  if (urlParams?.review === 'true') return goPreviousPath(urlParams);
  return goPreviousPath();
};
